import {
  Box,
  Button,
  Dialog,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { ReactNode, useState } from "react";
import { useQuery } from "react-query";
import { client } from "../dataProvider";
import TimelineIcon from "@material-ui/icons/Timeline";
import FeedbackIcon from "@material-ui/icons/Feedback";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { GrDocumentExcel } from "react-icons/gr";
import { TbLockSquare } from "react-icons/tb";
import { SiAdblock } from "react-icons/si";
import { RiUserSearchFill } from "react-icons/ri";
import { BsUiChecks } from "react-icons/bs";
import { LuUserRoundSearch } from "react-icons/lu";
import { MdOutlinePersonOff } from "react-icons/md";

const useStyles = makeStyles((theme) => ({
  strip: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    maxWidth: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    marginTop: -12,
    padding: theme.spacing(1.5, 3, 0, 3),
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  alertButton: {
    flex: "0 0 auto",
    width: 28,
    height: 28,
    padding: 0,
    overflow: "visible",
    borderRadius: 8,
    border: "1px solid rgba(244, 67, 54, 0.16)",
    background: "rgba(244, 67, 54, 0.04)",
    color: theme.palette.error.main,
    transition: theme.transitions.create(["background-color", "border-color"], {
      duration: theme.transitions.duration.shortest,
    }),
    "&:hover": {
      background: "rgba(244, 67, 54, 0.08)",
      borderColor: "rgba(244, 67, 54, 0.28)",
    },
    "& .MuiButton-label": {
      height: "100%",
      overflow: "visible",
    },
  },
  alertButtonInner: {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "visible",
  },
  alertIcon: {
    display: "flex",
    alignItems: "center",
    color: "inherit",
    flexShrink: 0,
  },
  alertCount: {
    position: "absolute",
    right: -16,
    top: -12,
    minHeight: 15,
    minWidth: 17,
    padding: "2px 5px 2px",
    borderRadius: 7,
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 10,
    fontWeight: 700,
    lineHeight: 0.8,
    boxSizing: "border-box",
    overflow: "visible",
  },
  appBarFallback: {
    width: 28,
    height: 28,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 999,
    border: "1px solid rgba(244, 67, 54, 0.14)",
    background: "rgba(244, 67, 54, 0.04)",
  },
}));

const initialData = {
  note_without_delivery: 0,
  delivery_stocked: 0,
  delivery_suspended: 0,
  route_not_left: 0,
  customer_order_to_schedule: 0,
  missing_subjects: 0,
  delivery_no_subjects: 0,
  missing_client_subjects: 0,
  delivery_withdrawn_alert: 0,
  delivery_withdrawn_alert_recurrent: 0,
};

export const NotificationIcons = () => {
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);

  const { data = initialData } = useQuery(
    [],
    () =>
      client("notifications", {
        method: "GET",
      }),
    {
      initialData,
    }
  );

  const handleClose = (_event: any, reason: any) => {
    if (reason && reason === "backdropClick") {
      setOpenDialog(false);
    }
  };
  const fontSize = 18;

  const rows = [
    data["note_without_delivery"] !== 0 && {
      title: "Bolle non assegnate",
      icon: <GrDocumentExcel size={fontSize} />,
      count: data["note_without_delivery"],
      href: "/notes/not-assigned",
    },
    data["delivery_stocked"] !== 0 && {
      title: "Giacenze",
      icon: <TbLockSquare size={fontSize} />,
      count: `G:${data["delivery_stocked"]}`,
      href: "/deliveries?displayedFilters=%7B%7D&filter=%7B%22delivery_states%22%3A%5B%22S%22%5D%7D&order=DESC&sort=id",
    },
    data["delivery_suspended"] !== 0 && {
      title: "Sospese",
      icon: <SiAdblock size={fontSize} />,
      count: `S:${data["delivery_suspended"]}`,
      href: "/deliveries?displayedFilters=%7B%7D&filter=%7B%22delivery_states%22%3A%5B%22SU%22%5D%7D&order=DESC&sort=id",
    },
    data["delivery_withdrawn_alert"] !== 0 && {
      title: "Ritiri spot in ritardo",
      icon: <AccessTimeIcon style={{ fontSize: fontSize }} />,
      count: `RP:${data["delivery_withdrawn_alert"]}`,
      href: '/deliveries?displayedFilters={"is_recurrent_child"%3Atrue%2C"withdraw_delay_alert"%3Atrue}&filter={"is_recurrent_child"%3Afalse%2C"withdraw_delay_alert"%3Atrue}&order=DESC&page=1&perPage=50&sort=id',
    },
    data["delivery_withdrawn_alert_recurrent"] !== 0 && {
      title: "Ritiri ricorrenti in ritardo",
      icon: <AccessTimeIcon style={{ fontSize: fontSize }} />,
      count: `RR:${data["delivery_withdrawn_alert_recurrent"]}`,
      href: '/deliveries?displayedFilters={"is_recurrent_child"%3Atrue%2C"withdraw_delay_alert"%3Atrue}&filter={"is_recurrent_child"%3Atrue%2C"withdraw_delay_alert"%3Atrue}&order=DESC&page=1&perPage=50&sort=id',
    },
    data["route_not_left"] !== 0 && {
      title: "Giri non partiti",
      icon: <TimelineIcon style={{ fontSize: fontSize }} />,
      count: data["route_not_left"],
      href: "/board_routes",
    },
    data["customer_order_to_schedule"] !== 0 && {
      title: "Ordini in sospeso",
      icon: <BsUiChecks size={fontSize} />,
      count: data["customer_order_to_schedule"],
      href: "/customer_orders",
    },
    data["delivery_no_subjects"] !== 0 && {
      title: "Missioni senza destinatario",
      icon: <MdOutlinePersonOff size={fontSize} />,
      count: data["delivery_no_subjects"],
      href: '/deliveries?displayedFilters={"no_subjects"%3Atrue}&filter={"no_subjects"%3Atrue}&order=DESC&page=1&perPage=50&sort=id',
    },
    data["missing_subjects"] !== 0 && {
      title: "Soggetti non risolti",
      icon: <LuUserRoundSearch size={fontSize} />,
      count: data["missing_subjects"],
      href: "/subjects-solver",
    },
    data["missing_client_subjects"] !== 0 && {
      title: "Soggetti ordini non risolti",
      icon: <RiUserSearchFill size={fontSize} />,
      count: data["missing_client_subjects"],
      href: "/subjects-solver",
    },
  ].filter(Boolean) as Array<{
    title: string;
    icon: ReactNode;
    count: string | number;
    href: string;
  }>;

  const totalCount = rows.reduce((sum, row) => {
    const numeric = typeof row.count === "number" ? row.count : parseInt(String(row.count).replace(/^[A-Z]+:/, ""), 10);
    return sum + (Number.isFinite(numeric) ? numeric : 0);
  }, 0);

  return (
    <>
      <Dialog open={openDialog} fullWidth maxWidth="md" onClose={handleClose}>
        <h2 style={{ textAlign: "center" }}>Notifiche</h2>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Tipo</TableCell>
              <TableCell>Num</TableCell>
              <TableCell>Link</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.title}>
                <TableCell>{row.title}</TableCell>
                <TableCell>
                  <Typography color="error">{row.count}</Typography>
                </TableCell>
                <TableCell>
                  <a target="_blank" href={row.href} rel="noreferrer">
                    Vai
                  </a>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Box p={2}>
          <Button onClick={() => setOpenDialog(false)}>Chiudi</Button>
        </Box>
      </Dialog>

      {rows.length > 0 ? (
        <Box style={{marginBottom: "0px"}} className={classes.strip} onClick={() => setOpenDialog(true)}>
          {rows.map((row) => (
            <Tooltip title={row.title} key={row.title} placement="bottom">
              <IconButton className={classes.alertButton} size="small">
                <span className={classes.alertButtonInner}>
                  <span className={classes.alertIcon}>{row.icon}</span>
                  <span className={classes.alertCount}>{row.count}</span>
                </span>
              </IconButton>
            </Tooltip>
          ))}
        </Box>
      ) : (
        <Box className={classes.appBarFallback} onClick={() => setOpenDialog(true)}>
          <span style={{ position: "relative", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <FeedbackIcon fontSize="small" style={{ fontSize: 18 }} />
            <span className={classes.alertCount} style={{ right: -6, top: -6 }}>
              {totalCount}
            </span>
          </span>
        </Box>
      )}
    </>
  );
};
